import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Category, CategoriesGQL } from 'src/app/graphql/user-service';
import { NotificationService } from '@akebono/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DefaultUrlSerializer, PRIMARY_OUTLET } from '@angular/router';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit, OnDestroy {
  @Input() onlyPopular = false;

  categories: Category[] = [];

  loading = false;

  subscription: Subscription = null;
  urlSerializer = new DefaultUrlSerializer();

  constructor(
    private translate: TranslateService,
    private notificationService: NotificationService,
    private categoriesGQL: CategoriesGQL,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.subscription = this.categoriesGQL
      .watch(
        {
          lang: this.translate.currentLang,
        },
        {
          fetchPolicy: 'cache-first',
        },
      )
      .valueChanges.subscribe(
        (result) => {
          this.loading = false;
          console.log('Categories response', result);

          if (result && result.data && result.data.yahooAuctionsCategories) {
            if (this.onlyPopular) {
              this.categories = result.data.yahooAuctionsCategories.filter((c) => c.isPopular);

              // this.categories.forEach((category) => {
              //   category.children = category.children.filter((c) => c.isPopular);
              // });
            } else {
              this.categories = result.data.yahooAuctionsCategories.filter(
                (c) => c.code || (c.useSearch && c.searchQuery),
              );
            }
          } else {
            this.notificationService.renderError('Empty response');
          }
        },
        (error) => {
          this.loading = false;
          console.log(error);
          this.notificationService.renderError('Error', error);
        },
      );
  }

  getPathname(path) {
    return this.urlSerializer.parse(path).root.children[PRIMARY_OUTLET].segments.join('/');
  }

  getQueryParams(path) {
    return this.urlSerializer.parse(path).queryParams;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
